const MEASUREMENT_ID = 'G-TRFLX2BXVE';

/**
 * Fire a GA4 page_view hit. Called automatically by PageTracker in App.js
 * on every React Router route change.
 */
export function pageview(path) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('config', MEASUREMENT_ID, { page_path: path });
}

/**
 * Fire a custom GA4 event.
 * @param {string} action  - Event name (e.g. 'campaign_created')
 * @param {object} params  - Optional event parameters
 */
export function gaEvent(action, params = {}) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', action, params);
}
